import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionSport } from './competition-sport'
import { competitionSportActions } from './competition-sport.actions'
import * as fromCompetitionSport from './competition-sport.reducer'
import { CompetitionSportService } from './competition-sport.service'

@Injectable()
export class CompetitionSportEffects extends ResourceEffects<CompetitionSport> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionSportService: CompetitionSportService
  ) {
    super(
      fromCompetitionSport.FEATURE_NAME,
      competitionSportService,
      competitionSportActions,
      actions$
    )
  }
}
